import template from 'text-loader!templates/reporting/wizard/excelContentSettings.html'
import StepView from 'views/reporting/wizard/stepView'
import 'backbone.marionette'
import session from 'models/sessionInstance';

var View = StepView.extend({
  template: template,
  className: "wizard-step rounded clearfix",
  triggers: {
    'click #include_clips_from_several_sources': 'click:include_clips_from_several_sources'
  },
  initialize: function () {
    this.on('click:include_clips_from_several_sources', () => {
      this.$('#include_clips_from_several_sources').toggleClass("checked");
      var value = this.$('#include_clips_from_several_sources').hasClass("checked");
      this.model.set({include_clips_from_several_sources: value});
    });

    StepView.prototype.initialize.call(this);
  },
  updateCheckboxes: function () {
    this.$('#include_clips_from_several_sources').removeClass("checked");

    if (this.model.get("include_clips_from_several_sources") === true) {
      this.$('#include_clips_from_several_sources').addClass("checked");
    }

  },
  onRender: function () {
    this.updateCheckboxes();
    this.$('.excel_hint').removeClass('hidden');
  },
  serializeData: function () {
    return {
      make_only_datasheet_default_in_reports: session.hasFeature('make_only_datasheet_default_in_reports')
    }
  }
});

export default View;

